import { useMemo } from "react";
import type { AmlogicDeviceSession } from "../../core/amlogic/multi/AmlogicDeviceSession";
import type { AmlogicBatchRunSnapshot } from "../../core/amlogic/multi/AmlogicBatchRunStore";

interface Props {
  sessions: readonly AmlogicDeviceSession[];
  batch?: AmlogicBatchRunSnapshot;
  filter: string;
  onFilterChange: (filter: string) => void;
}

export function AmlogicBatchLogTable({ sessions, batch, filter, onFilterChange }: Props) {
  const rows = useMemo(() => sessions
    .filter((session) => filter === "all" || session.id === filter)
    .flatMap((session) => session.logs
      .filter((entry) => !batch || entry.batchId === batch.id)
      .map((entry) => ({ ...entry, sessionId: session.id, label: session.label })))
    .sort((left, right) => Date.parse(left.timestamp) - Date.parse(right.timestamp))
    .slice(-40), [batch, filter, sessions]);

  return (
    <details className="amlogic-batch-log" open={Boolean(batch)}>
      <summary>Nhật ký batch {batch ? `· ${batch.id.slice(0, 8)}` : ""}</summary>
      <div className="amlogic-log-toolbar">
        <label>Thiết bị <select value={filter} onChange={(event) => onFilterChange(event.target.value)}><option value="all">Tất cả</option>{sessions.map((session) => <option value={session.id} key={session.id}>{session.label}</option>)}</select></label>
      </div>
      <div className="amlogic-table-scroll amlogic-log-scroll">
        <table className="amlogic-log-table"><thead><tr><th>Thời gian</th><th>Thiết bị</th><th>Nội dung</th></tr></thead><tbody>
          {rows.length === 0 && <tr><td colSpan={3} className="amlogic-empty-row">Chưa có log cho batch này.</td></tr>}
          {rows.map((row, index) => <tr key={`${row.sessionId}-${row.timestamp}-${index}`} title={row.jobId ? `Job ${row.jobId}` : undefined}><td>{new Date(row.timestamp).toLocaleTimeString("vi-VN")}</td><td>{row.label}</td><td>{row.message}</td></tr>)}
        </tbody></table>
      </div>
    </details>
  );
}
